import React, { useState } from 'react'
import { useSessionData } from '../../components/sessionContext'
import axios from 'axios'

// react router
import { withRouter } from 'react-router-dom'

// styles
import './Login.css'

// images
import logo from '../../images/logo.svg'

// semantic-ui
import {
  Grid,
  Header,
  Image,
  Message,
  Segment,
  Dimmer,
  Form,
  Loader,
  Button
} from 'semantic-ui-react'

const Login = props => {
  // session
  const session = useSessionData()

  // states
  const [loading, setLoading] = useState(false)
  const [email, setEmail] = useState(null)
  const [password, setPassword] = useState(null)
  const [error, setError] = useState(false)
  const [server, setServer] = useState('https://server.rehability.munogu.io')
  const [expired, setExpired] = useState(false)

  const handleChange = (event, { name, value }) => {
    setError(false)
    if (name === 'email') setEmail(value)
    if (name === 'password') setPassword(value)
    if (name === 'server') setServer(value)
  }
  const handleSubmit = event => {
    event.preventDefault()

    setLoading(true)
    setError(false)

    return axios.post(server + '/login', {
      login: email,
      password: password
    }, {
      credentials: 'same-origin'
    }).then(async res => {
      if (res.status === 200) {
        setLoading(false)
        setError(false)
        session.login({ ...res.data, server })
        props.history.push('/')
      } else {
        setLoading(false)
        setError(true)
      }
    }).catch(err => {
      console.error('an error occured while logging in')
      console.error(err)
      setLoading(false)
      setError(true)
    })
  }

  return (
    <div className='Login'>
      <Grid verticalAlign='middle' centered>
        <Grid.Row>
          <Grid.Column mobile={15} tablet={8} computer={6}>
            <Header as='h2' textAlign='center'>
              <Image circular src={logo} className='logo' />
              KIOSK
            </Header>
            {
              error ? <Message negative>
                <Message.Header>Login failed!</Message.Header>
                <p>Invalid email or password.</p>
              </Message> : ''
            }
            {
              expired ? <Message color='yellow'>
                <Message.Header>Session expired!</Message.Header>
                <p>Your session token has expired! Please login again to continue.</p>
              </Message> : ''
            }
            <Segment>
              {loading ? <Dimmer active inverted>
                <Loader inverted>Logging in</Loader>
              </Dimmer> : ''}
              <Form onSubmit={handleSubmit}>
                <Form.Field>
                  <Form.Input name='email' type='email' label='Email' placeholder='Your email address' required onChange={handleChange} />
                </Form.Field>
                <Form.Field>
                  <Form.Input name='password' type='password' label='Password' placeholder='Your password' required onChange={handleChange} />
                </Form.Field>
                <Form.Field required>
                  <Form.Input name='server' type='text' label='Server' value={server} placeholder='Server endpoint' required onChange={handleChange} />
                </Form.Field>
                <div className='clear'>
                  <Button type='submit' floated='right'>Login</Button>
                </div>
              </Form>
            </Segment>
          </Grid.Column>
        </Grid.Row>
      </Grid>
    </div>
  )

}

export default withRouter(Login)
